export const QUICK_CREATE_CATEGORIES = [
  {
    title: 'People',
    color: '#3b82f6',
    items: [
      { icon: 'fa-users', label: 'Customers' },
      { icon: 'fa-phone', label: 'Contacts' },
      { icon: 'fa-address-card', label: 'Staff' },
    ],
  },
  {
    title: 'Sales',
    color: '#ff6600',
    items: [
      { icon: 'fa-solid fa-gavel', label: 'Bids' },
      { icon: 'fa-solid fa-file-powerpoint', label: 'Proposals' },
      { icon: 'fa-solid fa-file-invoice', label: 'Change Orders' },
      { icon: 'fas fa-file-invoice', label: 'Purchase Orders' },
    ],
  },
  {
    title: 'Operations',
    color: '#22c55e',
    items: [
      { icon: 'fa-solid fa-tools', label: 'Jobsites' },
      { icon: 'fa-solid fa-warehouse', label: 'Warehouses' },
      { icon: 'fas fa-clipboard-check', label: 'Tasks' },
      { icon: 'fas fa-calendar-check', label: 'Task Templates' },
      { icon: 'fa-solid fa-receipt', label: 'Tickets' },
      { icon: 'fas fa-file-alt', label: 'Notes' },
    ],
  },
  {
    title: 'Supply Chain',
    color: '#a855f7',
    items: [
      { icon: 'fa-solid fa-toolbox', label: 'Vendors' },
      { icon: 'fa-solid fa-sitemap', label: 'Products' },
      { icon: 'fas fa-user-friends', label: 'Subcontractors' },
      { icon: 'fa-solid fa-toolbox', label: 'Services' },
    ],
  },
];
